﻿define(['jquery', 'pubsub', 'generalUtilities', 'moduleUtilities', 'userSearchService'], function agentsDeeplinkControl(
	$,
	pubsub,
	generalUtilities,
	moduleUtilities
) {
	// set up
	// -------------------------------------------

	'use strict';

	var module;

	module = {};
	module.private = {};
	module.properties = {};

	// utilities
	// -------------------------------------------
	module.private.determineQueryElements = function determineQueryElements(data) {
		var queryObject, requestObject;

		queryObject = {};
		requestObject = data.request;

		if (generalUtilities.prop(requestObject, 'Name')) {
			queryObject.Name = requestObject.Name;
		}
		if (generalUtilities.prop(requestObject, 'Keywords')) {
			queryObject.Keywords = requestObject.Keywords;
		}
		if (generalUtilities.prop(requestObject, 'RelationshipSearch')) {
			queryObject.RelationshipSearch = requestObject.RelationshipSearch;
		}
		if (generalUtilities.prop(requestObject, 'LanguagesSpoken')) {
			queryObject.LanguagesSpoken = requestObject.LanguagesSpoken;
		}
		if (generalUtilities.prop(requestObject, 'YearsOfExperience')) {
			queryObject.YearsOfExperience = requestObject.YearsOfExperience;
		}
		if (generalUtilities.prop(requestObject, '_locationName')) {
			queryObject._locationName = requestObject._locationName;
        }
        if (generalUtilities.prop(requestObject, '_subjectName')) {
            queryObject._subjectName = decodeURIComponent(requestObject._subjectName);
        }
		if (generalUtilities.prop(requestObject, 'Latitude')) {
			queryObject.Latitude = requestObject.Latitude;
		}
		if (generalUtilities.prop(requestObject, 'Latitude1')) {
			queryObject.Latitude1 = requestObject.Latitude1;
		}
		if (generalUtilities.prop(requestObject, 'Latitude2')) {
			queryObject.Latitude2 = requestObject.Latitude2;
		}
		if (generalUtilities.prop(requestObject, 'Latitude3')) {
			queryObject.Latitude3 = requestObject.Latitude3;
		}
		if (generalUtilities.prop(requestObject, 'Latitude4')) {
			queryObject.Latitude4 = requestObject.Latitude4;
		}
		if (generalUtilities.prop(requestObject, 'Longitude')) {
			queryObject.Longitude = requestObject.Longitude;
		}
		if (generalUtilities.prop(requestObject, 'Longitude1')) {
			queryObject.Longitude1 = requestObject.Longitude1;
		}
		if (generalUtilities.prop(requestObject, 'Longitude2')) {
			queryObject.Longitude2 = requestObject.Longitude2;
		}
		if (generalUtilities.prop(requestObject, 'Longitude3')) {
			queryObject.Longitude3 = requestObject.Longitude3;
		}
		if (generalUtilities.prop(requestObject, 'Longitude4')) {
			queryObject.Longitude4 = requestObject.Longitude4;
        }
		if (generalUtilities.prop(requestObject, '_subjectType')) {
			queryObject._subjectType = requestObject._subjectType;
		}
		if (generalUtilities.prop(requestObject, '_subject')) {
			queryObject._subject = requestObject._subject;
        }
        if (generalUtilities.prop(requestObject, 'CountryCode')) {
            queryObject.CountryCode = requestObject.CountryCode;
        }
        if (generalUtilities.prop(requestObject, 'SearchType')) {
            queryObject.SearchType = requestObject.SearchType;
        }
		return queryObject;
	};

	// event handlers
	// -------------------------------------------
	module.private.handleDataUserSearchBrowseSuccess = function handleDataUserSearchBrowseSuccess(e, data) {
		var queryObject, queryString, url;

		if (Modernizr.history) {
			queryObject = [];
			queryObject = module.private.determineQueryElements(data);
			queryString = $.param(queryObject);

			url = (queryString.length) ? generalUtilities.stringFormat('?{0}', queryString) : window.location.pathname;
			window.history.replaceState(data.request, 'Agents', url);
		}
	};

	module.private.handleDataUserSearchBrowse = function handleDataUserSearchBrowse(e, data) {
		if (data && data.response && data.response.Success && moduleUtilities.isOwnEvent(data, module.properties)) {
			module.private.handleDataUserSearchBrowseSuccess(e, data);
		}
	};

	module.private.init = function init(e, data) {
		module.properties.guid = data && data.guid ? data.guid : generalUtilities.uuid();
	};

	// external event bindings
	// -------------------------------------------

	pubsub.subscribe('uiWantsAgentsDeepLinkControlInit', module.private.init);
	pubsub.subscribe('dataUserSearchBrowse', module.private.handleDataUserSearchBrowse);

	// expose API
	// -------------------------------------------
	return module;
});
